import React from "react";
import { Dropdown } from "react-bootstrap";
import { FiMoreVertical } from "react-icons/fi";
import styles from "./CommonActionMenu.module.css";

const CommonActionMenu = ({ actions = [] }) => {
  return (
    <Dropdown align="end" renderMenuOnMount>
      <Dropdown.Toggle className={styles.menuBtn}>
        <FiMoreVertical />
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.dropdownMenu}>
        {actions.map((action, index) => (
          <Dropdown.Item
            key={index}
            className={action.danger ? "text-danger" : ""}
            onClick={action.onClick}
          >
            {action.icon} {action.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CommonActionMenu;